export default __webpack_public_path__ + "static/media/books.7b521e31.jpg";